import * as React from 'react';
import type {UiConfig} from './UiConfigProvider';
import {UiConfigProvider} from './UiConfigProvider';
import {
  useRpcMediaSmallScreen,
  useRpcMediaAnyCoarsePointer,
} from '../components/hooks/useMatchMedia/useRpcMatchMedia';

export const UiProvider: React.FC<UiConfig> = ({children, ...config}) => {
  /**
   * We initialize these hooks in the UiProvider so that their value is
   * available to all components on render. Otherwise, animated components
   * such as Dialog or Drawer wouldn't be animated properly on the first render.
   */
  const isSmallScreen = useRpcMediaSmallScreen();
  const isTouch = useRpcMediaAnyCoarsePointer();

  const stableConfig: UiConfig = React.useMemo(
    () => ({
      _internal_observability: config._internal_observability,
      _unstable_requestIframe: config._unstable_requestIframe,
      _unstable_getUILayers: config._unstable_getUILayers,
      _unstable_shouldSkipIframePortal: config._unstable_shouldSkipIframePortal,
      enableSailUiMultipleSelection: config.enableSailUiMultipleSelection,
      enableBaselineIntent: config.enableBaselineIntent,
      enableBottomSheets: config.enableBottomSheets,
      disableStablePopover: config.disableStablePopover,
      isSmallScreen,
      isTouch,
    }),
    [
      config._internal_observability,
      config._unstable_requestIframe,
      config._unstable_getUILayers,
      config._unstable_shouldSkipIframePortal,
      config.enableSailUiMultipleSelection,
      config.enableBaselineIntent,
      config.enableBottomSheets,
      config.disableStablePopover,
      isSmallScreen,
      isTouch,
    ],
  );

  return <UiConfigProvider config={stableConfig}>{children}</UiConfigProvider>;
};
